import { GeometryEditorContext, US_VIEWPORT } from '@cibo/mapgl'
import { Loading } from '@cibo/profile'
import { useParams } from 'react-router-dom'
import { useInventory } from '../../../../features/Inventories/queries/useInventory'
import { BoundariesMap } from './BoundariesMap'
import { SelectBasePeriod } from './SelectBasePeriod'

export const InventorySetup = () => {
  const { inventoryId } = useParams()
  const { data: inventory, isLoading } = useInventory(inventoryId)

  if (isLoading) return <Loading large />
  if (inventory?.item.status === 'open') {
    /**
     * This implementation of the draw + select maps is not ideal, and should be refactored for any
     * production MVP of this product. It loads the map 2x for each time it is loaded, and relies
     * on switching between the two maps to act on the map in two ways. This can and should be
     * accomplished in a single map once we have more certainty that this is the display direction
     * and when we're not under the gun to release a demo
     */
    console.log('DEMO Inventory Boundary Editor')
    return (
      <GeometryEditorContext initialViewport={US_VIEWPORT} displayFields={false}>
        <BoundariesMap />
      </GeometryEditorContext>
    )
  }
  return <SelectBasePeriod />
}
